import {
  Button,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useContext, useState } from "react";
import toast from "react-hot-toast";
import { AppContext } from "../../scripts/context/App";

import schema from "./schema";

const ERROR_INPUTS = {
  first_name: false,
  last_name: false,
  mobile: false,
  old_password: false,
  password: false,
  password_confirmation: false,
};

export default function UpdateInformation() {
  const { user, setState } = useContext(AppContext);
  const InitUserInformation = {
    first_name: user.first_name || "",
    last_name: user.last_name || "",
    mobile: user.mobile || "",
    old_password: "",
    password: "",
    password_confirmation: "",
  };
  const [userInformation, setUserInformation] = useState(InitUserInformation);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(ERROR_INPUTS);

  const handelChanges = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setUserInformation({ ...userInformation, [name]: value });
  };

  const handelSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setErrors(ERROR_INPUTS);

    schema
      .validate(userInformation, { abortEarly: false })
      .then(() => {
        setLoading(true);
        axios
          .post("/profile/update-data", userInformation)
          .then(({ data }) => {
            setLoading(false);
            toast.success("Your information has been updated");

            setState({
              user: {
                ...user,
                full_name: `${userInformation.first_name} ${userInformation.last_name}`,
                first_name: userInformation.first_name,
                last_name: userInformation.last_name,
                mobile: userInformation.mobile,
              },
            });
            setUserInformation({
              first_name: userInformation.first_name || "",
              last_name: userInformation.last_name || "",
              mobile: userInformation.mobile || "",
              old_password: "",
              password: "",
              password_confirmation: "",
            });
          })
          .catch(({ response }) => {
            setErrors(ERROR_INPUTS);
            setLoading(false);

            if (response.data.errors) {
              setErrors({
                ...errors,
                ...Object.keys(response.data.errors).map((key) => ({
                  [key]: response.data.errors[key][0],
                }))[0],
              });
            }
          });
      })
      .catch((error) => {
        setErrors(ERROR_INPUTS);

        setErrors(
          error.inner.reduce((acc: any, err: any) => {
            acc[err.path] = err.message;
            return acc;
          }, {})
        );
      });
  };

  return (
    <Box sx={{ mt: 4, pt: 3, borderTop: "1px solid #e0e0e0" }}>
      <Typography variant="h6" color="textPrimary" sx={{ mb: 1 }}>
        Update Information
      </Typography>
      <form onSubmit={handelSubmit}>
        <Stack direction="row" sx={{ flexWrap: "wrap", gap: 1 }}>
          <TextField
            size="medium"
            sx={{ maxWidth: 300, width: "100%" }}
            error={Boolean(errors.first_name)}
            helperText={errors.first_name}
            value={userInformation.first_name}
            onChange={handelChanges}
            name="first_name"
            id="first_name"
            label="First Name"
            variant="standard"
          />
          <TextField
            size="medium"
            sx={{ maxWidth: 300, width: "100%" }}
            error={Boolean(errors.last_name)}
            helperText={errors.last_name}
            value={userInformation.last_name}
            onChange={handelChanges}
            name="last_name"
            id="last_name"
            label="Last Name"
            variant="standard"
          />
          <TextField
            size="medium"
            sx={{ maxWidth: 300, width: "100%" }}
            error={Boolean(errors.mobile)}
            helperText={errors.mobile}
            value={userInformation.mobile}
            onChange={handelChanges}
            name="mobile"
            id="mobile"
            label="Mobile"
            variant="standard"
            type="number"
            onKeyDown={(e) =>
              ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
            }
          />
        </Stack>
        <br />
        <span>Password</span>
        <Stack direction="row" sx={{ mt: 1, flexWrap: "wrap", gap: 1 }}>
          <TextField
            size="medium"
            sx={{ maxWidth: 300, width: "100%" }}
            error={Boolean(errors.old_password)}
            helperText={errors.old_password}
            value={userInformation.old_password}
            onChange={handelChanges}
            name="old_password"
            id="old_password"
            label="Old Password"
            variant="standard"
            type="password"
          />
          <TextField
            size="medium"
            sx={{ maxWidth: 300, width: "100%" }}
            error={Boolean(errors.password)}
            helperText={errors.password}
            value={userInformation.password}
            onChange={handelChanges}
            name="password"
            id="password"
            label="Password"
            variant="standard"
            type="password"
          />
          <TextField
            size="medium"
            sx={{ maxWidth: 300, width: "100%" }}
            error={Boolean(errors.password_confirmation)}
            helperText={errors.password_confirmation}
            value={userInformation.password_confirmation}
            onChange={handelChanges}
            name="password_confirmation"
            id="password_confirmation"
            label="Password Confirmation"
            variant="standard"
            type="password"
          />
        </Stack>
        <Button
          sx={{ mt: 2 }}
          variant="contained"
          color="primary"
          type="submit"
          disabled={loading}
          startIcon={
            loading && (
              <CircularProgress
                sx={{ width: "15px !important", height: "15px !important" }}
              />
            )
          }
        >
          Save
        </Button>
      </form>
    </Box>
  );
}
